import {
  DatagridConfigurable,
  List,
  TextField,
  SearchInput,
  TopToolbar,
  SelectColumnsButton,
  CreateButton,
} from "react-admin";

import { CLIENT_SEARCH_SOURCE } from "@/constants/filters";

const ListActions = () => (
  <TopToolbar>
    <SelectColumnsButton />
    <CreateButton />
  </TopToolbar>
);

export const CountriesList = () => (
  <List
    filters={[
      <SearchInput
        key="search"
        placeholder="Search Country"
        source={CLIENT_SEARCH_SOURCE}
        alwaysOn
      />,
    ]}
    actions={<ListActions />}
    pagination={false}
    storeKey={false}
  >
    <DatagridConfigurable bulkActionButtons={false}>
      <TextField source="id" sortable={false} />
      <TextField source="name" sortable={false} />
      <TextField source="code" sortable={false} />
      <TextField source="heartbeatName" sortable={false} />
    </DatagridConfigurable>
  </List>
);
